export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]/i;

export const phoneRegex = /^[ ()]*([0-9][ ()]*){8}$/;

export const noNumberRegex = /\d/;

export const noLetterRegex = /[a-zA-Z æøåÆØÅ]/;

export const firstNameLastNameRegex = /^(\S*[a-zA-Z æøåÆØÅ]\S*\s){1,}\S*[a-zA-Z æøåÆØÅ]\S*$/;
